module.exports = __webpack_public_path__ + "img/6_75.8489ae44.png";